import service from '../service/enterprise'
import cardService from '../service/card'
import CONSTANT from '../constant/enterprise'
import _ from 'underscore'
export default {
  getEnterpriseRecommend ({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getRecommend().then(result => {
        resolve(result)
        commit(CONSTANT.ENTERPRISE_GET_RECOMMEND_SUCCESS, result)
        return result
      }, e => {
        reject(e)
        commit(CONSTANT.ENTERPRISE_GET_RECOMMEND_ERROR, e)
      })
    })
  },
  getEnterpriseAccessibility ({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getEnterpriseAccessibility().then(data => {
        resolve(data)
      }, e => {
        reject(e)
      })
    })
  },
  initEnterpriseCards ( {commit} ) {
    return commit(CONSTANT.ENTERPRISE_INIT_CARDS)
  },
  getEnterpriseValidCard ({ commit, state }, { pageNum = 1 }) {
    return new Promise((resolve, reject) => {
      return cardService.getUsefulCards({
        pageNum,
        pageSize: 2,
      }).then(data => {
        if (data.length === 0) {
          commit(CONSTANT.ENTERPRISE_GET_CARD_NOMORE_STATUS)
          return data
        }
        commit(CONSTANT.ENTERPRISE_GET_CARD_SUCCESS, {data, pageNum,})
        return data
      }, e => {
        commit(CONSTANT.ENTERPRISE_GET_CARD_ERROR)
      })
    })
  },
  getEnterpriseBillboards({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getEnterpriseBillboards().then(result => {
        commit(CONSTANT.ENTERPRISE_BILLBOARDS_GET_LIST_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.ENTERPRISE_BILLBOARDS_GET_LIST_ERROR, e)
        reject(e)
      })
    })
  },
  getEnterpriseShops({ commit }) {
    return new Promise((resolve, reject) => {
      return service.getEnterpriseShops().then(result => {
        commit(CONSTANT.ENTERPRISE_SHOPS_GET_LIST_SUCCESS, result)
        resolve(result)
      }, e => {
        commit(CONSTANT.ENTERPRISE_SHOPS_GET_LIST_ERROR, e)
        reject(e)
      })
    })
  }
}
